/**
 * Single-property template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import BannerHero from './lib/partials/BannerHero';
import PropertyMap from './lib/partials/PropertyMap';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Single-property';
const bannerHeroDom = document.querySelector(`[data-banner-hero]`);
const propertyMapDom = document.querySelector(`[data-property-map]`);

const contactDrawerToggleDoms = document.querySelectorAll('[data-contact-drawer-toggle]');
const contactDrawer = document.querySelector('[data-contact-drawer]');

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initBannerHero();
	initContactDrawerToggle();
	initMap();
}

/**
 * initBannerHero - Initialize the banner hero
 */
const initBannerHero = () => {
	Logger.log(`${NAME} > initBannerHero`);

	if (!bannerHeroDom) return;

	const el = new BannerHero(bannerHeroDom);
	el.init();
}

/**
 * initContactDrawerToggle - Initialize the contact drawer toggle
 */
const initContactDrawerToggle = () => {
	Logger.info(`${NAME} > initContactDrawerToggle`);

	if (!contactDrawerToggleDoms || !contactDrawer) return;

	contactDrawerToggleDoms.forEach((contactDrawerToggle) => {
		contactDrawerToggle.addEventListener('click', () => {
			contactDrawer.classList.toggle('single-contact-drawer--active');

			if (contactDrawer.classList.contains('single-contact-drawer--active')) {
				stopBodyScrolling(true);
			} else {
				stopBodyScrolling(false);
			}
		});
	});
}

/**
 * initMap - Initialize the PropertyMap partial
 */
const initMap = () => {
	Logger.info(`${NAME} > initMap`);

	if (!propertyMapDom) return;

	const el = new PropertyMap(propertyMapDom);
	el.init();
}

/**
 * stopBodyScrolling - Stop the body from scrolling
 */
function stopBodyScrolling(bool) {
	Logger.info(`${NAME} > stopBodyScrolling`);
	if (bool === true) {
		document.body.style.overflow = 'hidden'; document.getElementsByTagName('html')[0].style.overflow = `hidden`;
	} else {
		document.body.style.overflow = 'auto'; document.getElementsByTagName('html')[0].style.overflow = `auto`;
	}
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
